
ADILF.define('adilf/apps/social/promo-modules/social-media/views/list-view',['require','exports','module','streamhub-sdk/jquery','inherits','streamhub-sdk/ui/button','adilf/apps/social/promo-modules/collection-promo-base/views/list-view','streamhub-sdk/views/list-view','hgn!adilf/apps/social/promo-modules/social-media/views/templates/list-view','streamhub-sdk/util','adilf/context'],function (require, exports, module) {'use strict';
var jquery = require('streamhub-sdk/jquery');
var inherits = require('inherits');
var Button = require('streamhub-sdk/ui/button');
var CollectionPromoListView = require('adilf/apps/social/promo-modules/collection-promo-base/views/list-view');
var ListView = require('streamhub-sdk/views/list-view');
var template = require('hgn!adilf/apps/social/promo-modules/social-media/views/templates/list-view');
var util = require('streamhub-sdk/util');
var Context = require('adilf/context');

var SocialMediaPromoListView = function(opts) {
    opts = opts || {};
    CollectionPromoListView.call(this, opts);

    this.timeout = opts.timeout; // In Minutes
    this.slug = opts.slug || "Twitter Updates";
    this.theme = opts.theme || "default";
    this._initialAdded = false;
    this._waitingPeriodOver = false;
    this._loadMsgVisible = false;
    this.$loadingMsg = jquery('<div class="loading-msg"><img src="https://static.advance.net/static/common/img/loading-150.gif" / ><b style="margin-left:10px; color:#363636;">Loading Tweets...</b></div>');

    this._setupDOM();
};
inherits(SocialMediaPromoListView, CollectionPromoListView);

SocialMediaPromoListView.prototype.template = template;

SocialMediaPromoListView.prototype.selectors = {
    header: '.adi-ssm-header',
    slug: '.adi-smm-slug'
};

SocialMediaPromoListView.prototype._setupDOM = function() {
    this.$el.hide();
    setTimeout(function() {
        this.$loadingMsg.remove();
        this.$el.show();
        this._waitingPeriodOver = true;
    }.bind(this), 2000);
};

SocialMediaPromoListView.prototype._handleCloseButtonClick = function() {
    this.emit('killPromo.adi');
};

SocialMediaPromoListView.prototype.add = function(content, forcedIndex, opts) {
    // Skip if content item is older than {timeout} minutes
    if(new Date().getTime() - content.createdAt.getTime() > (this.timeout * 60 * 1000)) {
        return;
    }
    if(!this._initialAdded) {
        this.$el.addClass(this.theme);
        this.$el.parent().addClass('active');

        this.$el.find(this.selectors.slug).text(this.slug);

        this._closeButton = new Button(this._handleCloseButtonClick.bind(this), {
            label: 'Close',
            className: 'smm-close'
        });
        this.$el.find(this.selectors.header).append(this._closeButton.$el);
        this._closeButton.render();

        this.$el.parent().append(this.$loadingMsg);
        this._loadMsgVisible = true;
        this.emit('rendered.adi');
    }

    if(this.views.length > 0) {
        var viewToRemove = this.views[this.views.length-1];
        this.remove(viewToRemove).then(function() {
            // Ensure .more won't let more through right away,
            // we already have more than we want.
            this.more.setGoal(0);
            // Unshift content to more stream
            this.saveForLater(viewToRemove.content);
            CollectionPromoListView.prototype.add.call(this, content, forcedIndex, opts);
        }.bind(this));
    } else {
        this._initialAdded = true;
        if(this._loadMsgVisible && this._waitingPeriodOver) {
            this.$loadingMsg.remove();
        }
        CollectionPromoListView.prototype.add.call(this, content, forcedIndex, opts);
    }
};

SocialMediaPromoListView.prototype.remove = function (content) {
    var view = content.el ? content : this.getContentView(content); //duck type for ContentView
    var viewIndex = this.views.indexOf(view);
    var d = jquery.Deferred();

    // Return false if the provided view is not managed by this ListView
    if (viewIndex === -1) {
        d.resolve(false);
    }

    // Remove from DOM
    view.$el.fadeOut('slow', function() {
        view.$el.parent().remove();
        // Remove from this.views[]
        this.views.splice(viewIndex, 1);
        d.resolve(true);
    }.bind(this));

    return d.promise();

};

SocialMediaPromoListView.prototype.destroy = function () {
    this.$el.slideUp('fast');
    this.template = null;
    this.undelegateEvents();
};

module.exports = SocialMediaPromoListView;
});
